import { useQuery } from '@tanstack/react-query';
import { reportAPI } from 'api/report';
import { TileInfo } from 'app/home/index.functions';
import { ChartMetricsInfoType } from 'components/metric/MetricViewer';
import { useKpiChartBlockSummaryStats } from 'components/report-content/components/kpi-chart/hooks/useKpiChartBlockSummaryStats';

// Fired only on hover (enabled) so a grid of tiles doesn't trigger one request per tile on mount.
export function useTileReportSummaryStats(tile: TileInfo, enabled: boolean): ChartMetricsInfoType | null {
    const elementId = tile.element_id ?? 0;
    const segmentValueId = tile.segment_value_id ?? 0;
    const isReport = tile.element_type === 'internal report';

    const { data: previewComponent } = useQuery({
        queryKey: [`tile_report_preview_component_${elementId}`],
        queryFn: () => reportAPI.getPreviewComponent(elementId),
        enabled: enabled && isReport && elementId > 0,
    });

    return useKpiChartBlockSummaryStats(
        previewComponent
            ? { internalName: previewComponent.internalName, settings: previewComponent.settings }
            : undefined,
        previewComponent?.displayMasks ?? [],
        elementId,
        segmentValueId,
    );
}
